import React from 'react';

function faviconUrl(url) {
  try {
    const u = new URL(url);
    return `${u.origin}/favicon.ico`;
  } catch (e) {
    return null;
  }
}

export default function AppCard({ app, onEdit, onRemove, compact = false, showIcons = true, onOpenWindow }) {
  let hostname = app.url;
  try { hostname = new URL(app.url).hostname } catch (e) { /* keep raw */ }
  
  const title = app.title || app.name || 'App';

  return (
    <article className={`app-card ${compact ? 'compact' : ''}`} onClick={() => onOpenWindow && onOpenWindow(app)} onDoubleClick={() => window.open(app.url, '_blank')}>
      <div className="app-card-top">
        {showIcons ? (
          <img className="app-icon" src={app.icon || faviconUrl(app.url) || '/favicon.ico'} alt="icon" onError={(e)=> e.currentTarget.src='/favicon.ico'} />
        ) : (
          <div style={{width:56,height:56,borderRadius:14,background:'linear-gradient(180deg,#f1f5f9,#fff)',display:'flex',alignItems:'center',justifyContent:'center',color:'#111',fontWeight:700}}>{title[0]}</div>
        )}
        <div className="app-actions">
          <button className="icon-btn" title="Editer" onClick={(e)=>{ e.stopPropagation(); onEdit(); }}>✎</button>
          <button className="icon-btn danger" title="Supprimer" onClick={(e)=>{ e.stopPropagation(); onRemove(); }}>✕</button>
        </div>
      </div>
      <div className="app-card-body">
        <div className="app-title">{title}</div>
        <a className="app-url" href={app.url} target="_blank" rel="noreferrer">{hostname}</a>
      </div>
    </article>
  );
}
